<template>
  <div class="content is_wrap">
    <h1>Tableau de bord</h1>

    <div class="content is_actions"></div>

    <div class="content is_grid">
      <!-- Carte 1 : Pourcentage -->
      <div class="card is_wrap">
        <h3>% d’employés ayant utilisé le service (année en cours)</h3>
        <p>
          Taux d'adoption du service : part de vos employés qui ont pris au
          moins un rendez-vous via la plateforme depuis le début de l'année en
          cours.
        </p>
        <div class="circle-wrapper">
          <svg width="130" height="130">
            <defs>
              <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stop-color="#FFC90E" />
                <stop offset="100%" stop-color="white" />
              </linearGradient>
            </defs>
            <circle class="bg" cx="65" cy="65" r="55" />
            <circle
              class="fg"
              :stroke-dasharray="circumference"
              :stroke-dashoffset="percentageUsageOffset"
              cx="65"
              cy="65"
              r="55"
            />
            <text x="65" y="71" text-anchor="middle" class="circle-text">
              {{ percentageUsage }}%
            </text>
          </svg>
        </div>
      </div>

      <!-- Carte 2 : Ratio -->
      <div class="card is_wrap">
        <h3>Ratio consultations/employé (année en cours)</h3>
        <p>
          Intensité d'utilisation du service : combien de consultations chaque
          employé a pris en moyenne depuis le début de l'année. Complète le taux
          d'adoption en indiquant si les utilisateurs reviennent.
        </p>
        <div class="circle-wrapper">
          <svg width="130" height="130">
            <circle class="bg" cx="65" cy="65" r="55" />
            <circle
              class="fg"
              :stroke-dasharray="circumference"
              :stroke-dashoffset="consultationRatioOffset"
              cx="65"
              cy="65"
              r="55"
            />
            <text x="65" y="71" text-anchor="middle" class="circle-text">
              {{ consultationRatio }}
            </text>
          </svg>
        </div>
      </div>

      <!-- Carte 3 : Moyenne de connexions -->
      <div class="card is_wrap">
        <h3>Total des connexions (année en cours)</h3>
        <p>
          Volume total d'activité sur la plateforme depuis le début de l'année.
          Contrairement au taux d'adoption, cet indicateur compte chaque
          connexion, y compris celles qui n'ont pas mené à un rendez-vous. La
          consultation de la boîte à outils, de l'encyclopédie et du blogue
          n'est pas comptabilisée.
        </p>
        <div class="circle-wrapper">
          <svg width="130" height="130">
            <circle class="bg" cx="65" cy="65" r="55" />
            <circle
              class="fg"
              :stroke-dasharray="circumference"
              :stroke-dashoffset="totalLoginsOffset"
              cx="65"
              cy="65"
              r="55"
            />
            <text x="65" y="71" text-anchor="middle" class="circle-text">
              {{ totalLogins }}
            </text>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EntrepriseStats",
  data() {
    const radius = 55;
    return {
      radius,
      circumference: 2 * Math.PI * radius,
    };
  },
  computed: {
    percentageUsage() {
      return this.$store.getters["statistiques/getStats"]?.percentageUsage || 0;
    },
    consultationRatio() {
      return (
        this.$store.getters["statistiques/getStats"]?.consultationRatio || 0
      );
    },
    totalLogins() {
      return this.$store.getters["statistiques/getStats"]?.totalLogins || 0;
    },
    percentageUsageOffset() {
      return this.circumference * (1 - this.percentageUsage / 100);
    },
    consultationRatioOffset() {
      const ratio = Math.min(this.consultationRatio / 10, 1);
      return this.circumference * (1 - ratio);
    },
    totalLoginsOffset() {
      const ratio = Math.min(this.totalLogins / 365, 1);
      return this.circumference * (1 - ratio);
    },
  },
  async mounted() {
    const entrepriseId = this.$route.params.id;
    try {
      await this.$store.dispatch("statistiques/fetchStats", entrepriseId);
    } catch (error) {
      console.error("Erreur lors du chargement des statistiques :", error);
    }
  },
};
</script>

<style scoped>
/* STYLES GÉNÉRAUX */
.content.is_wrap {
  background-color: white;
  border-radius: 10px;
  max-width: 1200px;
  width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem;
  margin: 4rem auto 4rem auto;
}

.content.is_actions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 3rem;
  margin-bottom: 3rem;
  margin-top: 2rem;
  border-top: 1px solid gray;
}

.content.is_grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  width: 100%;
}

/* CARTE */
.card.is_wrap {
  background-color: #f6f6f6;
  border-radius: 0.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  text-align: center;
}

/* CERCLE */
.circle-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  padding-top: 1.5rem;
}

.bg {
  fill: none;
  stroke: #e6e6e6;
  stroke-width: 15;
}

.fg {
  fill: none;
  stroke: url(#grad1);
  stroke-width: 15;
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: center;
  transition: stroke-dashoffset 1s ease-out;
}

.circle-text {
  font-size: 1.25rem;
  font-weight: bold;
  fill: #000;
  dominant-baseline: middle;
  alignment-baseline: middle;
  pointer-events: none;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .content.is_wrap {
    padding: 1rem;
  }

  .content.is_actions {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    padding-top: 2rem;
  }
}
</style>
